import { HttpParams } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var MotorService = /** @class */ (function () {
    function MotorService(http) {
        this.http = http;
    }
    MotorService.prototype.getDevices = function () {
        return this.http.get('motor/devices');
    };
    MotorService.prototype.getReadings = function (filters) {
        var params = new HttpParams();
        if (filters && filters.deviceId && filters.deviceId !== 'all') {
            params = params.set('deviceId', filters.deviceId);
        }
        if (filters && filters.from) {
            params = params.set('from', filters.from);
        }
        if (filters && filters.to) {
            params = params.set('to', filters.to);
        }
        if (filters && filters.limit != null) {
            params = params.set('limit', String(filters.limit));
        }
        if (filters && filters.offset != null) {
            params = params.set('offset', String(filters.offset));
        }
        if (filters && filters.mode) {
            params = params.set('mode', filters.mode);
        }
        return this.http.get('motor/readings', { params: params });
    };
    MotorService.prototype.getDashboardSummary = function (filters) {
        var params = new HttpParams();
        if (filters && filters.deviceId && filters.deviceId !== 'all') {
            params = params.set('deviceId', filters.deviceId);
        }
        if (filters && filters.from) {
            params = params.set('from', filters.from);
        }
        if (filters && filters.to) {
            params = params.set('to', filters.to);
        }
        return this.http.get('motor/dashboard/summary', { params: params });
    };
    MotorService.prototype.getAnalytics = function (filters) {
        var params = new HttpParams();
        params = params.set('deviceId', filters.deviceId);
        if (filters && filters.from) {
            params = params.set('from', filters.from);
        }
        if (filters && filters.to) {
            params = params.set('to', filters.to);
        }
        return this.http.get('motor/analytics', { params: params });
    };
    MotorService.prototype.getThresholds = function (deviceId) { return this.http.get("motor/thresholds", { params: { deviceId: deviceId } }); };
    MotorService.prototype.saveThresholds = function (body) { return this.http.post("motor/thresholds", body); };
    MotorService.prototype.getAlerts = function (filters) { return this.http.get("motor/alerts", { params: filters }); };
    MotorService.prototype.ackAlert = function (id) { return this.http.post("motor/alerts/" + id + "/ack", {}); };
    MotorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MotorService_Factory() { return new MotorService(i0.ɵɵinject(i1.HttpClient)); }, token: MotorService, providedIn: "root" });
    return MotorService;
}());
export { MotorService };
